import { factory, Flex, Grid, Box, AspectRatioKeeper, VideoPlayer } from '@kohler-dsm-library/kohler-core';
import { CloseIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import classes from './OverlayVideo.module.css.mjs';

const OverlayVideo = factory((props, ref) => {
  const { onClose, closeCTA, zIndex, ...rest } = props;
  return /* @__PURE__ */ React.createElement(Flex, { className: clsx(classes.overlayVideoWrapper, "kohler-overlay-video-root"), zIndex, ref }, /* @__PURE__ */ React.createElement(Grid, { className: classes.overlayVideoGrid }, (onClose || closeCTA) && /* @__PURE__ */ React.createElement(
    Box,
    {
      display: "flex",
      component: "button",
      type: "button",
      onClick: onClose,
      ...closeCTA,
      className: clsx(classes.overlayVideoCloseIcon, closeCTA?.className)
    },
    /* @__PURE__ */ React.createElement(CloseIcon, null)
  ), /* @__PURE__ */ React.createElement(AspectRatioKeeper, { component: "div", aspectRatio: "16:9", className: classes.overlayVideoContainer }, /* @__PURE__ */ React.createElement(VideoPlayer, { autoPlay: true, ...rest }))));
});

export { OverlayVideo };
